// src/Routes.js

import React from "react";
import { lazy } from "react";

// 使用懒加载导入组件
const Home = lazy(() => import("../pages/home/index"));
const MyList = lazy(() => import("../pages/mylist/index"));
const Mine = lazy(() => import("../pages/mine/index"));
const WatchVideo = lazy(() => import("../pages/watch/index"));
const MyHistory = lazy(() => import("../pages/myhistory/index"));
const About = lazy(() => import("../pages/about/index"));
const MyOrderList = lazy(() => import("../pages/myorderlist/index"));
const MyTestPage = lazy(() => import("../pages/mytestpage/index"));
const Feedback = lazy(() => import("../pages/feedback/index"));
const Search = lazy(() => import("../pages/search/index"));
const DistributionPage = lazy(() => import("../pages/distributionpage/index"));

const routesConfig = (myTokenVal, myLangGet, setMyLangGet) => [
  {
    path: "/home",
    element: <Home myTokenVal={myTokenVal} myLangGet={myLangGet} />,
    meta: { isGloblePlayer: false },
  },
  {
    path: "/mylist",
    element: <MyList myTokenVal={myTokenVal} />,
    meta: { isGloblePlayer: false },
  },
  {
    path: "/mine",
    element: <Mine myTokenVal={myTokenVal} myLangGet={myLangGet} setMyLangGet={setMyLangGet} />,
    meta: { isGloblePlayer: false },
  },
  {
    path: "/watch",
    element: <WatchVideo myTokenVal={myTokenVal} />,
    meta: { isGloblePlayer: false },
  },
  {
    path: "/myhistory",
    element: <MyHistory myTokenVal={myTokenVal} />,
    meta: { isGloblePlayer: false },
  },
  {
    path: "/About",
    element: <About myTokenVal={myTokenVal} />,
    meta: { isGloblePlayer: false },
  },
  {
    path: "/myorderlist",
    element: <MyOrderList myTokenVal={myTokenVal} />,
    meta: { isGloblePlayer: false },
  },
  {
    path: "/mytestpage",
    element: <MyTestPage myTokenVal={myTokenVal} />,
    meta: { isGloblePlayer: false },
  },
  {
    path: "/feedback",
    element: <Feedback myTokenVal={myTokenVal} />,
    meta: { isGloblePlayer: false },
  },
  {
    path: "/distribution",
    element: <DistributionPage myTokenVal={myTokenVal} />,
    meta: { isGloblePlayer: false },
  },
  {
    path: "/search",
    element: <Search myTokenVal={myTokenVal} />,
    meta: { isGloblePlayer: false },
  },
  {
    path: "*",
    element: <Home myTokenVal={myTokenVal} myLangGet={myLangGet} />,
    meta: { isGloblePlayer: false },
  },
];

export default routesConfig;
